import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';
import { Survey } from '../../../../api/general/models';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Survey>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const surveyByEmailReducer = createReducer<State, Actions>(initialState, {
  [actions.getSurveyByEmail.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getSurveyByEmail.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getSurveyByEmail.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getSurveyByEmail.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.updateSurveyByEmail.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateSurveyByEmail.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateSurveyByEmail.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateSurveyByEmail.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default surveyByEmailReducer;
